"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('clothes-gloves-two', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M22 4H23C27.6912 4 30.0367 4 31.6526 5.23988C32.0686 5.55908 32.4409 5.93144 32.7601 6.34743C34 7.96327 34 10.3088 34 15C34 15 41 15 41 21V26C41 32 34 32 34 32V38H35C36.6569 38 38 39.3431 38 41C38 42.6569 36.6569 44 35 44H9C7.34315 44 6 42.6569 6 41C6 39.3431 7.34315 38 9 38H10V16C10 10.3431 10 7.51472 11.7574 5.75736C13.5147 4 16.3431 4 22 4Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M34 38H10M34 38V32C34 32 41 32 41 26C41 24 41 24 41 21C41 15 34 15 34 15M34 38H35C36.6569 38 38 39.3431 38 41V41C38 42.6569 36.6569 44 35 44H9C7.34315 44 6 42.6569 6 41V41C6 39.3431 7.34315 38 9 38H10M10 38V16C10 10.3431 10 7.51472 11.7574 5.75736C13.5147 4 16.3431 4 22 4H23C27.6912 4 30.0367 4 31.6526 5.23988C32.0686 5.55908 32.4409 5.93144 32.7601 6.34743C34 7.96327 34 10.3088 34 15V15M34 22V15",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;